import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser } from "server/models"
import { StateType, deepCopy } from "client/utils"
import {
    StoreType,
    TaskObjectProps,
    TaskParticipantList,
    UserFilters,

    SortUsers,
    AddTaskParticipants,
    LoadTaskParticipants,

    setTaskParticipantList,
    setNotAssignedTaskParticipantIds,
    setNotAssignedTaskParticipantSelected,
    setNotAssignedTaskParticipantSort,
    setNotAssignedTaskParticipantFilters,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

const AddParticipants = ({
    task,
}: TaskObjectProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)

    const taskParticipantList = useSelector((state: StoreType) => state.taskParticipant.taskParticipantList)
    const userIds = useSelector((state: StoreType) => state.taskParticipant.notAssignedUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.taskParticipant.notAssignedUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.taskParticipant.notAssignedUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.taskParticipant.notAssignedUsers.filters)
    const selected = useSelector((state: StoreType) => state.taskParticipant.notAssignedUsers.selected)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const availableUserIds = project.id
            ? (projectUserList && projectUserList[project.id]) || []
            : (accountUserList && accountUserList[userData.accountId]) || []

        const taskParticipants = taskParticipantList[task.id] || []
        const filteredUserIds = sortedUserIds.filter((userId) => (
            availableUserIds.includes(userId) && !taskParticipants.includes(userId)
        ))
        dispatch(setNotAssignedTaskParticipantIds(filteredUserIds))
        dispatch(setNotAssignedTaskParticipantSelected([]))
    }, [accountUserList, projectUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setNotAssignedTaskParticipantSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setNotAssignedTaskParticipantFilters(newFilters))
        dispatch(setNotAssignedTaskParticipantSelected([]))
    }

    const assignParticipants = () => {
        setSaveState(PENDING)
        AddTaskParticipants(selected, task.id).then(() => {
            LoadTaskParticipants(task.id).then((res) => {
                const participantListCopy: TaskParticipantList = deepCopy(taskParticipantList)
                participantListCopy[task.id] = res
                dispatch(setTaskParticipantList(participantListCopy))

                if (isMounted) {
                    setSaveState(IDLE)
                    dispatch(closeModal())
                }
            })
        })
    }

    const columns = Columns(task)

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.addParticipant_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="taskParticipants"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button
                        variant="success"
                        disabled={!selected || selected.length === 0}
                        onClick={assignParticipants}
                    >
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default AddParticipants
